import {
  Column,
  Entity,
  Index,
  OneToMany,
  PrimaryGeneratedColumn,
} from "typeorm";
import { Branches } from "./branches.entity";
import { CxBrand } from "./cx-brand.entity";
import { Services } from "./services.entity";

@Index("index_clients_on_code", ["code"], { unique: true })
@Index("clients_pkey", ["id"], { unique: true })
@Entity("clients", { schema: "public", synchronize: false, })
export class Clients {
  @PrimaryGeneratedColumn({ type: "integer", name: "id" })
  id: number;

  @Column("character varying", { name: "name" })
  name: string;

  @Column("character varying", { name: "code" })
  code: string;

  @Column("timestamp without time zone", { name: "created_at" })
  createdAt: Date;

  @Column("timestamp without time zone", { name: "updated_at" })
  updatedAt: Date;

  @Column("text", {
    name: "training_app_allow_ip_addresses",
    default: () => "''",
  })
  trainingAppAllowIpAddresses: string;

  @Column("integer", { name: "contract_state", default: () => "0" })
  contractState: number;

  @Column("text", { name: "note", nullable: true })
  note: string | null;

  @Column("boolean", {
    name: "user_download_limit_flag",
    default: () => "false",
  })
  userDownloadLimitFlag: boolean;

  @Column("boolean", {
    name: "first_device_needs_approval_flag",
    default: () => "false",
  })
  firstDeviceNeedsApprovalFlag: boolean;

  @Column("boolean", {
    name: "student_change_password_flag",
    default: () => "true",
  })
  studentChangePasswordFlag: boolean;

  @Column("boolean", { name: "skip_device_auth", default: () => "false" })
  skipDeviceAuth: boolean;

  @OneToMany(() => Branches, (branches) => branches.client)
  branches: Branches[];

  @OneToMany(() => Services, (services) => services.client)
  services: Services[];


  // ======================================================
  // CXサーベイ用に追加
  // ======================================================
  @OneToMany(() => CxBrand, cxBrand => cxBrand.client)
  cxBrands: CxBrand[];

}
